import { render, staticRenderFns } from "./MenuAccordion.vue?vue&type=template&id=23dfb7c1&scoped=true&"
import script from "./MenuAccordion.vue?vue&type=script&lang=js&"
export * from "./MenuAccordion.vue?vue&type=script&lang=js&"
import style0 from "./MenuAccordion.vue?vue&type=style&index=0&id=23dfb7c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dfb7c1",
  null
  
)

export default component.exports